import { Params } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { scanningType } from '../../../shared/constants/scanning';
import { Api } from '../../../shared/constants/api';
import { IFindingUrlContext } from '../../../shared/interfaces/finding.interface';
import { $viewIssuesParams } from '../constants/view-issues-params';
import { SharedCommonUtility } from '../../../shared/utils/common.utility';

export function getQueryParams(url: string): Record<string, string | string[]> {
  const [, queryString] = url.split('?');
  const httpParams: HttpParams = new HttpParams({ fromString: queryString });

  const paramsObject: Record<string, string | string[]> = {};
  for (const key of httpParams.keys()) {
    const allValues: string[] = httpParams.getAll(key);
    paramsObject[key] = allValues.length > 1 ? allValues : allValues[0];
  }
  return paramsObject;
}

/**
 * merges extra params into passed url
 *
 * @param url original url
 * @param extraParams query params to be merged into original url
 * @returns a tuple [urlWithoutParams, params]
 */
export function mergeUrlParams(url: string, extraParams: Params): [string, Record<string, string | string[]>, string] {
  let [urlWithoutParams] = url.split('?');

  let fragment: string = null;

  if (urlWithoutParams.indexOf('#') > 0) {
    [urlWithoutParams, fragment] = urlWithoutParams.split('#');
  }

  const paramsObject: Record<string, string | string[]> = getQueryParams(url);
  const queryParams: Record<string, string | string[]> = {
    ...paramsObject,
    ...extraParams,
  };

  return [urlWithoutParams, queryParams, fragment];
}

export function getFindingUrl(context: IFindingUrlContext, type?: scanningType): string {
  const hasNoUrlQuery: boolean = SharedCommonUtility.isNullishOrEmpty(context.urlQuery);
  const urlQuery: string = hasNoUrlQuery ? '' : `?${context.urlQuery}`;
  switch (type) {
    case scanningType.mobile:
      const mobileScanResultsUrl: string = `${Api.websitesAndApps}/${Api.mobile_scans}/${Api.scan_results}/${context.scanId}`;
      const mobileScanFindingsUrl: string = `${Api.mobile_app_report}/${Api.rules}/${context.ruleId}`;
      return `/${mobileScanResultsUrl}/${mobileScanFindingsUrl}${urlQuery}`;
    case scanningType.automatedUserFlow:
      const scanResultsUrl: string = `${Api.scans}/${Api.scan_results}/${context.scanId}`;
      const scanFindingsUrl: string = `${Api.scan_point_report}/${context.auditedDocumentId}/${Api.pages}/${context.pageId}/${context.tool}/${context.ruleId}`;
      return `/${scanResultsUrl}/${scanFindingsUrl}${urlQuery}`;
    default:
      const redirectUrl: string =
        `/${Api.scans}/${Api.scan_results}/${context.scanId}/${Api.aggregated_report}` +
        `/${context.tool}/${context.ruleId}${urlQuery}`;
      if (context.issueId) {
        return `${redirectUrl}${urlQuery ? '&' : '?'}${$viewIssuesParams.issueId}=${context.issueId}`;
      }
      return redirectUrl;
  }
}
